import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdoptCodeBookMutationVariables = Types.Exact<{
  object: Types.Jurisdiction_Adopted_Codes_Insert_Input;
}>;


export type AdoptCodeBookMutation = { __typename?: 'mutation_root', insert_jurisdiction_adopted_codes_one?: { __typename?: 'jurisdiction_adopted_codes', jurisdiction_id: any, code_book_id: any } | null };


export const AdoptCodeBookDocument = gql`
    mutation adoptCodeBook($object: jurisdiction_adopted_codes_insert_input!) {
  insert_jurisdiction_adopted_codes_one(
    object: $object
    on_conflict: {constraint: jurisdiction_adopted_codes_pkey, update_columns: [discipline, adopted_on, notes, sort_order]}
  ) {
    jurisdiction_id
    code_book_id
  }
}
    `;
export type AdoptCodeBookMutationFn = Apollo.MutationFunction<AdoptCodeBookMutation, AdoptCodeBookMutationVariables>;

/**
 * __useAdoptCodeBookMutation__
 *
 * To run a mutation, you first call `useAdoptCodeBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdoptCodeBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adoptCodeBookMutation, { data, loading, error }] = useAdoptCodeBookMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdoptCodeBookMutation(baseOptions?: Apollo.MutationHookOptions<AdoptCodeBookMutation, AdoptCodeBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdoptCodeBookMutation, AdoptCodeBookMutationVariables>(AdoptCodeBookDocument, options);
      }
export type AdoptCodeBookMutationHookResult = ReturnType<typeof useAdoptCodeBookMutation>;
export type AdoptCodeBookMutationResult = Apollo.MutationResult<AdoptCodeBookMutation>;
export type AdoptCodeBookMutationOptions = Apollo.BaseMutationOptions<AdoptCodeBookMutation, AdoptCodeBookMutationVariables>;